var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVolumeinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.072.372a1.125 1.125 0 1 0-.642 2.157 6.754 6.754 0 0 1 0 12.942 1.125 1.125 0 1 0 .642 2.157 9.004 9.004 0 0 0 0-17.256"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.547 5.954a1.125 1.125 0 0 0-1.591 1.591c.55.551.795.824.795 1.455 0 .63-.245.904-.795 1.454a1.125 1.125 0 0 0 1.59 1.592l.03-.03C17.15 11.444 18 10.593 18 9s-.85-2.443-1.425-3.016l-.03-.03zm-4.171-3.699c0-1.927-2.262-2.962-3.72-1.704L4.081 4.5H2.25A2.25 2.25 0 0 0 0 6.75v4.501a2.25 2.25 0 0 0 2.25 2.25h1.832l4.573 3.949c1.458 1.258 3.721.223 3.721-1.704z"
})));
export default SvgVolumeinline;